export const icons = {
    NavBarIcons: {
        Hammer: require("./NavBar/Hammer.png"),
        NewCase: require("./NavBar/NewCase.png"),
        AddCaseType: require("./NavBar/AddCaseType.png"),
        AllCasesType: require("./NavBar/AllCasesType.png"),
        AllManagers: require("./NavBar/AllManagers.png"),
        Manager: require("./NavBar/Manager.png"),
        UpdateCase: require("./NavBar/UpdateCase.png"),
    },

    Search: {
        MagnifyingGlass: require("./Search/MagnifyingGlass.png"),
    },

    Button: {
        DownArrow: require("./Button/DownArrow.png"),
        X: require("./Button/X.png"),

    },

    SigningFields: {
        signature: require("./HammerInAFile.png"),
        email: require("./OpenBook.png"),
        phone: require("./PictureCatch.png"),
        initials: require("./NavBar/Manager.png"),
        text: require("./Weight.png"),
        date: require("./NavBar/UpdateCase.png"),
        checkbox: require("./NavBar/NewCase.png"),
        idnumber: require("./NavBar/AllCasesType.png"),
    }
}